import React from 'react';

export function MyButton() {
    return (
        <div>
            <button style={{ color: 'blue', fontSize:'2rem' }}>My Button</button>
        </div>
    );
}